import { useEffect, useState } from 'react';
import { useConfigStore } from '../store/config-store.js';
import { getSocket } from '../lib/socket.js';

/**
 * Bootstrap-Hook: einmaliges Laden + WebSocket-Subscribe für Live-Updates.
 * Live-Pushes von anderen Admin-Clients aktualisieren `live`, der Draft
 * wird neu nachgeladen, damit der Diff korrekt zurückgesetzt wird.
 */
export function useConfigBootstrap(): { error: string | null } {
  const [error, setError] = useState<string | null>(null);
  const loadDraft = useConfigStore((s) => s.loadDraft);
  const loadLive = useConfigStore((s) => s.loadLive);

  useEffect(() => {
    void (async () => {
      await loadDraft();
      await loadLive();
    })();

    const socket = getSocket();
    const onConfig = (): void => {
      void loadDraft();
      void loadLive();
    };
    socket.on('config:update', onConfig);
    socket.on('connect_error', (err) => setError(err.message));

    return () => {
      socket.off('config:update', onConfig);
      socket.off('connect_error');
    };
  }, [loadDraft, loadLive]);

  return { error };
}
